module.exports = [
	{
		"name": "Тополь sp.",
		"longitude": 53.86016666666667,
		"latitude": 27.641972222222222,
		"height": 27.4,
		"diameter": 1.24,
		"age": 75,
		"color": "#2e8151",
		"money": 9.810451733370666,
		"money50": 490.5225866685333
	},
	{
		"name": "Вяз шершавый",
		"longitude": 53.8395,
		"latitude": 27.620722222222224,
		"height": 19.8,
		"diameter": 0.65,
		"age": 45,
		"color": "#003b19",
		"money": 33.33864910286708,
		"money50": 1666.932455143354
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.89772222222222,
		"latitude": 27.56872222222222,
		"height": 26,
		"diameter": 1.46,
		"age": 65,
		"color": "#2e8151",
		"money": 7.129189767967524,
		"money50": 356.45948839837615
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.85494444444445,
		"latitude": 27.573083333333333,
		"height": 30.3,
		"diameter": 1.12,
		"age": ">180",
		"color": "#799665",
		"money": 6.548790674221279,
		"money50": 327.439533711064
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.85436111111111,
		"latitude": 27.574472222222223,
		"height": 26.4,
		"diameter": 1.1500000000000001,
		"age": ">180",
		"color": "#799665",
		"money": 13.608073809316453,
		"money50": 680.4036904658227
	},
	{
		"name": "Ясень обыкновенный",
		"longitude": 53.85286111111111,
		"latitude": 27.576305555555557,
		"height": 27.7,
		"diameter": 0.96,
		"age": ">100",
		"color": "#2e5225",
		"money": 1.7366725202810327,
		"money50": 86.83362601405163
	},
	{
		"name": "Сосна sp.",
		"longitude": 53.85238888888889,
		"latitude": 27.577083333333334,
		"height": 26.5,
		"diameter": 0.62,
		"age": ">140",
		"color": "#b4cb44",
		"money": 23.763094740853678,
		"money50": 1188.1547370426838
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.85241666666667,
		"latitude": 27.577333333333332,
		"height": 27.4,
		"diameter": 1.1,
		"age": ">120",
		"color": "#a06e17",
		"money": 4.5459924997856325,
		"money50": 227.29962498928163
	},
	{
		"name": "Лиственница европейская",
		"longitude": 53.85191666666667,
		"latitude": 27.579583333333332,
		"height": 35.6,
		"diameter": 0.76,
		"age": ">120",
		"color": "#38b97d",
		"money": 32.724332146602364,
		"money50": 1636.2166073301182
	},
	{
		"name": "Береза повислая",
		"longitude": 53.851888888888894,
		"latitude": 27.580222222222222,
		"height": 36.4,
		"diameter": 0.86,
		"age": ">100",
		"color": "#00875a",
		"money": 10.524989177529731,
		"money50": 526.2494588764865
	},
	{
		"name": "Сосна веймутова",
		"longitude": 53.85208333333333,
		"latitude": 27.580666666666666,
		"height": 26.4,
		"diameter": 0.7000000000000001,
		"age": 55,
		"color": "#81b344",
		"money": 9.5396661194166,
		"money50": 476.98330597083
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.85077777777778,
		"latitude": 27.579444444444444,
		"height": 32.8,
		"diameter": 1.56,
		"age": ">130",
		"color": "#6a9974",
		"money": 23.119134259962824,
		"money50": 1155.9567129981413
	},
	{
		"name": "Ясень обыкновенный",
		"longitude": 53.85238888888889,
		"latitude": 27.57997222222222,
		"height": 26.9,
		"diameter": 1.21,
		"age": ">130",
		"color": "#2e5225",
		"money": 17.76424583100338,
		"money50": 888.212291550169
	},
	{
		"name": "Ель европейская",
		"longitude": 53.852583333333335,
		"latitude": 27.576249999999998,
		"height": 23.2,
		"diameter": 0.75,
		"age": 110,
		"color": "#1b6639",
		"money": 3.409672847547071,
		"money50": 170.48364237735353
	},
	{
		"name": "Клен сахаристый",
		"longitude": 53.895944444444446,
		"latitude": 27.521666666666665,
		"height": 22.6,
		"diameter": 0.76,
		"age": 65,
		"color": "#255b3b",
		"money": 10.934645048883139,
		"money50": 546.732252444157
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.89447222222222,
		"latitude": 27.530416666666667,
		"height": 19.8,
		"diameter": 0.92,
		"age": 90,
		"color": "#a06e17",
		"money": 17.350370540979505,
		"money50": 867.5185270489752
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.89458333333333,
		"latitude": 27.53136111111111,
		"height": 23.9,
		"diameter": 0.8,
		"age": ">100",
		"color": "#a06e17",
		"money": 12.956735956800143,
		"money50": 647.8367978400072
	},
	{
		"name": "Клен сахаристый",
		"longitude": 53.89363888888889,
		"latitude": 27.527694444444442,
		"height": 20.5,
		"diameter": 1.08,
		"age": 65,
		"color": "#255b3b",
		"money": 20.029515227249043,
		"money50": 1001.4757613624521
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.8935,
		"latitude": 27.52733333333333,
		"height": 26.1,
		"diameter": 0.86,
		"age": ">70",
		"color": "#799665",
		"money": 8.931190978153987,
		"money50": 446.55954890769937
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.89372222222222,
		"latitude": 27.52725,
		"height": 19.7,
		"diameter": 0.7000000000000001,
		"age": 67,
		"color": "#a06e17",
		"money": 12.849158455066775,
		"money50": 642.4579227533387
	},
	{
		"name": "Клен сахаристый",
		"longitude": 53.894527777777775,
		"latitude": 27.5275,
		"height": 20.5,
		"diameter": 1.04,
		"age": 55,
		"color": "#255b3b",
		"money": 26.00265186703497,
		"money50": 1300.1325933517485
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.894666666666666,
		"latitude": 27.527416666666667,
		"height": 24.7,
		"diameter": 0.64,
		"age": 65,
		"color": "#a06e17",
		"money": 13.466950998541916,
		"money50": 673.3475499270958
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.949,
		"latitude": 27.62547222222222,
		"height": 24.9,
		"diameter": 0.66,
		"age": 65,
		"color": "#a06e17",
		"money": 14.437752639943486,
		"money50": 721.8876319971744
	},
	{
		"name": "Клен ложноплатановый",
		"longitude": 53.92513888888889,
		"latitude": 27.605305555555557,
		"height": 17.1,
		"diameter": 0.5700000000000001,
		"age": 60,
		"color": "#317a4e",
		"money": 3.168705229016758,
		"money50": 158.4352614508379
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.92744444444444,
		"latitude": 27.598277777777778,
		"height": 27.5,
		"diameter": 1.1500000000000001,
		"age": 60,
		"color": "#2e8151",
		"money": 25.17086510308023,
		"money50": 1258.5432551540116
	},
	{
		"name": "Клен остролистный",
		"longitude": 53.909388888888884,
		"latitude": 27.58786111111111,
		"height": 20.7,
		"diameter": 0.73,
		"age": 75,
		"color": "#2f8953",
		"money": 14.683461348036383,
		"money50": 734.1730674018191
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.91186111111111,
		"latitude": 27.58625,
		"height": 24.7,
		"diameter": 1.3900000000000001,
		"age": "",
		"color": "#2e8151",
		"money": 22.07997208782295,
		"money50": 1103.9986043911474
	},
	{
		"name": "Сосна обыкновенная",
		"longitude": 53.963638888888894,
		"latitude": 27.580444444444446,
		"height": 15.2,
		"diameter": 0.8300000000000001,
		"age": ">130",
		"color": "#81966a",
		"money": 2.0598536193289037,
		"money50": 102.99268096644518
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.963638888888894,
		"latitude": 27.580277777777777,
		"height": 24.5,
		"diameter": 0.97,
		"age": ">120",
		"color": "#799665",
		"money": 6.7177288646095805,
		"money50": 335.886443230479
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.881861111111114,
		"latitude": 27.54302777777778,
		"height": 24.5,
		"diameter": 1.08,
		"age": 100,
		"color": "#a06e17",
		"money": 24.206462610505124,
		"money50": 1210.3231305252561
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.88641666666667,
		"latitude": 27.54638888888889,
		"height": 26.3,
		"diameter": 1.05,
		"age": ">120",
		"color": "#799665",
		"money": 8.449816251743478,
		"money50": 422.4908125871739
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.885666666666665,
		"latitude": 27.56116666666667,
		"height": 23.5,
		"diameter": 1,
		"age": ">100",
		"color": "#a06e17",
		"money": 19.906073155387247,
		"money50": 995.3036577693624
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.848333333333336,
		"latitude": 27.513694444444443,
		"height": 21.1,
		"diameter": 1.08,
		"age": ">110",
		"color": "#a06e17",
		"money": 20.84719841149625,
		"money50": 1042.3599205748126
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.84602777777778,
		"latitude": 27.51227777777778,
		"height": 25.1,
		"diameter": 1.1,
		"age": ">140",
		"color": "#a06e17",
		"money": 18.865931420779937,
		"money50": 943.2965710389968
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.85113888888889,
		"latitude": 27.50852777777778,
		"height": 21.3,
		"diameter": 0.89,
		"age": ">120",
		"color": "#799665",
		"money": 4.91668669887925,
		"money50": 245.8343349439625
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.85230555555556,
		"latitude": 27.50925,
		"height": 21.6,
		"diameter": 0.93,
		"age": 100,
		"color": "#a06e17",
		"money": 15.824769094350629,
		"money50": 791.2384547175315
	},
	{
		"name": "Лиственница польская",
		"longitude": 53.85275,
		"latitude": 27.503805555555555,
		"height": 19,
		"diameter": 0.73,
		"age": ">140",
		"color": "#66c395",
		"money": 1.940005435686781,
		"money50": 97.00027178433905
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.85325,
		"latitude": 27.505861111111113,
		"height": 23,
		"diameter": 1.18,
		"age": ">110",
		"color": "#a06e17",
		"money": 27.127488255996063,
		"money50": 1356.3744127998032
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.854222222222226,
		"latitude": 27.511777777777777,
		"height": 20.4,
		"diameter": 0.99,
		"age": 98,
		"color": "#a06e17",
		"money": 20.69991041148523,
		"money50": 1034.9955205742615
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.85516666666667,
		"latitude": 27.512416666666667,
		"height": 19.3,
		"diameter": 0.75,
		"age": 85,
		"color": "#a06e17",
		"money": 11.239519497044451,
		"money50": 561.9759748522225
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.851,
		"latitude": 27.50883333333333,
		"height": 24.7,
		"diameter": 0.96,
		"age": ">140",
		"color": "#799665",
		"money": 12.713964856664049,
		"money50": 635.6982428332025
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.8865,
		"latitude": 27.551111111111112,
		"height": 23.8,
		"diameter": 0.9500000000000001,
		"age": 55,
		"color": "#a06e17",
		"money": 40.02806367448976,
		"money50": 2001.403183724488
	},
	{
		"name": "Береза повислая",
		"longitude": 53.88625,
		"latitude": 27.551472222222223,
		"height": 20.5,
		"diameter": 0.67,
		"age": 65,
		"color": "#00875a",
		"money": 5.811694550434175,
		"money50": 290.5847275217087
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.88183333333333,
		"latitude": 27.561027777777777,
		"height": 21,
		"diameter": 0.8,
		"age": 60,
		"color": "#799665",
		"money": 7.531974541589475,
		"money50": 376.59872707947375
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.86855555555556,
		"latitude": 27.555027777777777,
		"height": 24,
		"diameter": 1,
		"age": ">110",
		"color": "#a06e17",
		"money": 20.329606626778467,
		"money50": 1016.4803313389234
	},
	{
		"name": "Ясень обыкновенный",
		"longitude": 53.884388888888886,
		"latitude": 27.538666666666668,
		"height": 24,
		"diameter": 0.84,
		"age": ">130",
		"color": "#2e5225",
		"money": 6.638848202598243,
		"money50": 331.94241012991216
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.88605555555556,
		"latitude": 27.54763888888889,
		"height": 24.7,
		"diameter": 1.05,
		"age": 80,
		"color": "#a06e17",
		"money": 28.193140823363517,
		"money50": 1409.657041168176
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.884277777777775,
		"latitude": 27.56116666666667,
		"height": 21.6,
		"diameter": 0.8,
		"age": 60,
		"color": "#799665",
		"money": 7.747173814206318,
		"money50": 387.3586907103159
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.90541666666667,
		"latitude": 27.615083333333335,
		"height": 25.9,
		"diameter": 0.86,
		"age": ">120",
		"color": "#a06e17",
		"money": 13.729784886942339,
		"money50": 686.4892443471169
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.90483333333333,
		"latitude": 27.61452777777778,
		"height": 28.7,
		"diameter": 0.9400000000000001,
		"age": ">120",
		"color": "#a06e17",
		"money": 18.176266022912035,
		"money50": 908.8133011456017
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.90475,
		"latitude": 27.61463888888889,
		"height": 30.3,
		"diameter": 0.99,
		"age": ">120",
		"color": "#a06e17",
		"money": 21.28531511769239,
		"money50": 1064.2657558846195
	},
	{
		"name": "Лиственница европейская",
		"longitude": 53.90463888888889,
		"latitude": 27.615166666666667,
		"height": 27,
		"diameter": 0.78,
		"age": ">150",
		"color": "#38b97d",
		"money": 4.538160266320094,
		"money50": 226.9080133160047
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.904944444444446,
		"latitude": 27.61625,
		"height": 20.5,
		"diameter": 0.88,
		"age": "> 120",
		"color": "#a06e17",
		"money": 11.378532956204388,
		"money50": 568.9266478102194
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.90508333333333,
		"latitude": 27.615972222222222,
		"height": 25.4,
		"diameter": 1.05,
		"age": ">70",
		"color": "#a06e17",
		"money": 37.27560435061248,
		"money50": 1863.7802175306242
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.89102777777778,
		"latitude": 27.605555555555558,
		"height": 28.5,
		"diameter": 1.24,
		"age": ">70",
		"color": "#2e8151",
		"money": 22.8459521099362,
		"money50": 1142.2976054968099
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.904444444444444,
		"latitude": 27.614805555555556,
		"height": 23.8,
		"diameter": 0.8,
		"age": ">120",
		"color": "#a06e17",
		"money": 10.917520030544827,
		"money50": 545.8760015272413
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.903888888888886,
		"latitude": 27.60252777777778,
		"height": 15,
		"diameter": 0.87,
		"age": 50,
		"color": "#799665",
		"money": 7.519518049602064,
		"money50": 375.97590248010323
	},
	{
		"name": "Каштан конский",
		"longitude": 53.90852777777778,
		"latitude": 27.509527777777777,
		"height": 14.8,
		"diameter": 0.97,
		"age": "",
		"color": "#31995b",
		"money": 12.557100975318646,
		"money50": 627.8550487659322
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.90897222222222,
		"latitude": 27.512527777777777,
		"height": 24.7,
		"diameter": 0.86,
		"age": "",
		"color": "#2e8151",
		"money": 9.523901333099833,
		"money50": 476.19506665499165
	},
	{
		"name": "Клен сахаристый",
		"longitude": 53.899,
		"latitude": 27.50663888888889,
		"height": 27,
		"diameter": 1.11,
		"age": "",
		"color": "#255b3b",
		"money": 21.673762920362197,
		"money50": 1083.6881460181098
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.91197222222222,
		"latitude": 27.51311111111111,
		"height": 38.3,
		"diameter": 1.18,
		"age": "",
		"color": "#2e8151",
		"money": 27.802498137781786,
		"money50": 1390.1249068890893
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.90461111111111,
		"latitude": 27.451444444444444,
		"height": 19.3,
		"diameter": 0.86,
		"age": "",
		"color": "#a06e17",
		"money": 14.778219768913912,
		"money50": 738.9109884456956
	},
	{
		"name": "Клен платановидный",
		"longitude": 53.916333333333334,
		"latitude": 27.554444444444446,
		"height": 22.9,
		"diameter": 0.8,
		"age": ">110",
		"color": "#45845e",
		"money": 5.993850347744434,
		"money50": 299.6925173872217
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.89666666666667,
		"latitude": 27.541583333333335,
		"height": 30.5,
		"diameter": 1.08,
		"age": ">70",
		"color": "#2e8151",
		"money": 18.546774090891304,
		"money50": 927.3387045445652
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.89555555555555,
		"latitude": 27.540222222222223,
		"height": 23.1,
		"diameter": 1.05,
		"age": 85,
		"color": "#a06e17",
		"money": 26.36686449472458,
		"money50": 1318.343224736229
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.91197222222222,
		"latitude": 27.56277777777778,
		"height": 22.1,
		"diameter": 0.89,
		"age": 70,
		"color": "#a06e17",
		"money": 18.12342171548711,
		"money50": 906.1710857743554
	},
	{
		"name": "Вяз шершавый",
		"longitude": 53.90869444444444,
		"latitude": 27.561583333333335,
		"height": 25.2,
		"diameter": 0.78,
		"age": 60,
		"color": "#003b19",
		"money": 12.84277317823069,
		"money50": 642.1386589115345
	},
	{
		"name": "Вяз шершавый",
		"longitude": 53.909444444444446,
		"latitude": 27.5595,
		"height": 31.5,
		"diameter": 0.89,
		"age": 60,
		"color": "#003b19",
		"money": 20.90064232921706,
		"money50": 1045.032116460853
	},
	{
		"name": "Ясень обыкновенный",
		"longitude": 53.901805555555555,
		"latitude": 27.56286111111111,
		"height": 31.3,
		"diameter": 0.84,
		"age": 140,
		"color": "#2e5225",
		"money": 8.633338252663775,
		"money50": 431.6669126331887
	},
	{
		"name": "Клен платановидный",
		"longitude": 53.90188888888889,
		"latitude": 27.563222222222223,
		"height": 26.7,
		"diameter": 0.91,
		"age": 140,
		"color": "#45845e",
		"money": 8.64310707257161,
		"money50": 432.1553536285805
	},
	{
		"name": "Клен платановидный",
		"longitude": 53.90172222222222,
		"latitude": 27.56313888888889,
		"height": 27.6,
		"diameter": 0.92,
		"age": 140,
		"color": "#45845e",
		"money": 9.131888158932446,
		"money50": 456.5944079466223
	},
	{
		"name": "Клен платановидный",
		"longitude": 53.901916666666665,
		"latitude": 27.563277777777778,
		"height": 30.5,
		"diameter": 0.86,
		"age": 140,
		"color": "#45845e",
		"money": 8.818050648936257,
		"money50": 440.90253244681287
	},
	{
		"name": "Вяз шершавый",
		"longitude": 53.85138888888889,
		"latitude": 27.563750000000002,
		"height": 30.3,
		"diameter": 0.76,
		"age": 95,
		"color": "#003b19",
		"money": 11.402351105546279,
		"money50": 570.117555277314
	},
	{
		"name": "Вяз шершавый",
		"longitude": 53.8525,
		"latitude": 27.56577777777778,
		"height": 25,
		"diameter": 0.86,
		"age": 95,
		"color": "#003b19",
		"money": 12.046517279967562,
		"money50": 602.325863998378
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.90288888888889,
		"latitude": 27.570083333333333,
		"height": 31.9,
		"diameter": 0.8200000000000001,
		"age": 125,
		"color": "#a06e17",
		"money": 15.373949641962522,
		"money50": 768.6974820981261
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.903194444444445,
		"latitude": 27.570333333333334,
		"height": 38.5,
		"diameter": 1.37,
		"age": ">80",
		"color": "#6a9974",
		"money": 33.240322849103855,
		"money50": 1662.0161424551927
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.90313888888889,
		"latitude": 27.570805555555555,
		"height": 41.4,
		"diameter": 1.1500000000000001,
		"age": ">80",
		"color": "#6a9974",
		"money": 25.186011148151998,
		"money50": 1259.3005574075999
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.90313888888889,
		"latitude": 27.570805555555555,
		"height": 32.5,
		"diameter": 1.23,
		"age": ">80",
		"color": "#6a9974",
		"money": 22.61814340513542,
		"money50": 1130.907170256771
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.90236111111111,
		"latitude": 27.571638888888888,
		"height": 40,
		"diameter": 1.27,
		"age": ">80",
		"color": "#6a9974",
		"money": 29.677738422402562,
		"money50": 1483.8869211201281
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.90222222222222,
		"latitude": 27.571583333333333,
		"height": 38.6,
		"diameter": 1.46,
		"age": ">80",
		"color": "#6a9974",
		"money": 37.849172216784396,
		"money50": 1892.4586108392198
	},
	{
		"name": "Ольха черная",
		"longitude": 53.902027777777775,
		"latitude": 27.571805555555557,
		"height": 27.9,
		"diameter": 0.8300000000000001,
		"age": 100,
		"color": "#03441d",
		"money": 7.53578985727899,
		"money50": 376.78949286394953
	},
	{
		"name": "Сосна обыкновенная",
		"longitude": 53.90175,
		"latitude": 27.575916666666668,
		"height": 19,
		"diameter": 0.61,
		"age": ">200",
		"color": "#81966a",
		"money": 0.8609420394814808,
		"money50": 43.04710197407404
	},
	{
		"name": "Тополь sp.",
		"longitude": 53.90236111111111,
		"latitude": 27.575083333333332,
		"height": 37.6,
		"diameter": 1.4000000000000001,
		"age": ">120",
		"color": "#2e8151",
		"money": 23.05240274239907,
		"money50": 1152.6201371199536
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.904222222222224,
		"latitude": 27.573055555555555,
		"height": 22.9,
		"diameter": 0.84,
		"age": ">180",
		"color": "#799665",
		"money": 3.1815976514631683,
		"money50": 159.07988257315841
	},
	{
		"name": "Ольха черная",
		"longitude": 53.90325,
		"latitude": 27.571,
		"height": 30.5,
		"diameter": 0.8300000000000001,
		"age": ">120",
		"color": "#03441d",
		"money": 6.970657560289773,
		"money50": 348.53287801448863
	},
	{
		"name": "Вяз шершавый",
		"longitude": 53.85622222222222,
		"latitude": 27.568,
		"height": 37.4,
		"diameter": 0.88,
		"age": 73,
		"color": "#003b19",
		"money": 24.2608500008412,
		"money50": 1213.0425000420598
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.90625,
		"latitude": 27.564805555555555,
		"height": 33.1,
		"diameter": 1.34,
		"age": 73,
		"color": "#6a9974",
		"money": 30.985508111175943,
		"money50": 1549.275405558797
	},
	{
		"name": "Тополь белый",
		"longitude": 53.90702777777778,
		"latitude": 27.56513888888889,
		"height": 35.7,
		"diameter": 1.46,
		"age": 73,
		"color": "#35aa65",
		"money": 39.67299243241184,
		"money50": 1983.649621620592
	},
	{
		"name": "Ясень sp.",
		"longitude": 53.90763888888889,
		"latitude": 27.550666666666668,
		"height": 25,
		"diameter": 0.96,
		"age": 75,
		"color": "#2e5225",
		"money": 19.299743669737104,
		"money50": 964.9871834868552
	},
	{
		"name": "Орех манчжурский",
		"longitude": 53.857416666666666,
		"latitude": 27.566694444444444,
		"height": 31.2,
		"diameter": 1.02,
		"age": 60,
		"color": "#47600a",
		"money": 27.19092636270086,
		"money50": 1359.546318135043
	},
	{
		"name": "Орех манчжурский",
		"longitude": 53.857416666666666,
		"latitude": 27.583111111111112,
		"height": 28.3,
		"diameter": 0.97,
		"age": 60,
		"color": "#47600a",
		"money": 22.304832707188137,
		"money50": 1115.241635359407
	},
	{
		"name": "Дуб черешчатый",
		"longitude": 53.90591666666666,
		"latitude": 27.565250000000002,
		"height": 26.3,
		"diameter": 0.72,
		"age": 73,
		"color": "#a06e17",
		"money": 18.148181751134775,
		"money50": 907.4090875567388
	},
	{
		"name": "Вяз шершавый",
		"longitude": 53.8585,
		"latitude": 27.58138888888889,
		"height": 28.6,
		"diameter": 0.9400000000000001,
		"age": 73,
		"color": "#003b19",
		"money": 21.1685351687578,
		"money50": 1058.42675843789
	},
	{
		"name": "Клен сахаристый",
		"longitude": 53.858444444444444,
		"latitude": 27.581777777777777,
		"height": 35.8,
		"diameter": 1.05,
		"age": 75,
		"color": "#255b3b",
		"money": 33.06211947798128,
		"money50": 1653.1059738990639
	},
	{
		"name": "Ясень sp.",
		"longitude": 53.919333333333334,
		"latitude": 27.53286111111111,
		"height": 30.1,
		"diameter": 0.73,
		"age": 75,
		"color": "#2e5225",
		"money": 13.436349192198238,
		"money50": 671.8174596099119
	},
	{
		"name": "Липа мелколистная",
		"longitude": 53.91844444444444,
		"latitude": 27.534166666666668,
		"height": 22.4,
		"diameter": 1.02,
		"age": ">160",
		"color": "#799665",
		"money": 5.145023336863938,
		"money50": 257.25116684319687
	},
	{
		"name": "Тополь канадский",
		"longitude": 53.91883333333333,
		"latitude": 27.52025,
		"height": 38.5,
		"diameter": 1.05,
		"age": 65,
		"color": "#6a9974",
		"money": 25.533377500515527,
		"money50": 1276.6688750257763
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/trees_data.json
 ** module id = 316
 ** module chunks = 0
 **/